export const NEW_LINE_DELIMITER = '<break />';
